__turbopack_context__.v({
  "bottom": "DiscoveryFooterNav-module__b98fKW__bottom",
  "brand": "DiscoveryFooterNav-module__b98fKW__brand",
  "chalkboardGreen": "DiscoveryFooterNav-module__b98fKW__chalkboardGreen",
  "column": "DiscoveryFooterNav-module__b98fKW__column",
  "columnHeading": "DiscoveryFooterNav-module__b98fKW__columnHeading",
  "columns": "DiscoveryFooterNav-module__b98fKW__columns",
  "copyright": "DiscoveryFooterNav-module__b98fKW__copyright",
  "discoveryChromePulse": "DiscoveryFooterNav-module__b98fKW__discoveryChromePulse",
  "divider": "DiscoveryFooterNav-module__b98fKW__divider",
  "footer": "DiscoveryFooterNav-module__b98fKW__footer",
  "inner": "DiscoveryFooterNav-module__b98fKW__inner",
  "legalLink": "DiscoveryFooterNav-module__b98fKW__legalLink",
  "legalList": "DiscoveryFooterNav-module__b98fKW__legalList",
  "link": "DiscoveryFooterNav-module__b98fKW__link",
  "linkList": "DiscoveryFooterNav-module__b98fKW__linkList",
  "loading": "DiscoveryFooterNav-module__b98fKW__loading",
  "logo": "DiscoveryFooterNav-module__b98fKW__logo",
  "logoLink": "DiscoveryFooterNav-module__b98fKW__logoLink",
  "skeletonBone": "DiscoveryFooterNav-module__b98fKW__skeletonBone",
  "skeletonColumnHeading": "DiscoveryFooterNav-module__b98fKW__skeletonColumnHeading",
  "skeletonCopyright": "DiscoveryFooterNav-module__b98fKW__skeletonCopyright",
  "skeletonFooterLink": "DiscoveryFooterNav-module__b98fKW__skeletonFooterLink",
  "skeletonLegal": "DiscoveryFooterNav-module__b98fKW__skeletonLegal",
  "skeletonSocial": "DiscoveryFooterNav-module__b98fKW__skeletonSocial",
  "socialIcon": "DiscoveryFooterNav-module__b98fKW__socialIcon",
  "socialLink": "DiscoveryFooterNav-module__b98fKW__socialLink",
  "socialList": "DiscoveryFooterNav-module__b98fKW__socialList",
  "subtlePaper": "DiscoveryFooterNav-module__b98fKW__subtlePaper",
  "top": "DiscoveryFooterNav-module__b98fKW__top",
});
